<template>
    <div>
        <button class="btn btn-primary mb-3" @click="open_add_voucher = true">
            <i class="fas fa-plus"></i>&nbsp; Add Voucher
        </button>
        <table class="table table-striped" v-if="vouchers.length > 0">
            <thead>
                <tr>
                    <th
                        class="cursor-pointer"
                        @click="sortByColumn('code')"
                        scope="col"
                    >
                        Discount Code
                        <span
                            style="font-size: 12px; color: #5d5de4;
                           text-decoration: underline; margin-left: 5px;"
                            >Sort</span
                        >
                        <span v-show="sortOrder['code'] === 'asc'">&#9650;</span
                        ><span v-show="sortOrder['code'] === 'desc'"
                            >&#9660;</span
                        >
                    </th>

                    <th
                        class="cursor-pointer"
                        @click="sortByColumn('start_at')"
                        scope="col"
                    >
                        Start Date
                        <span
                            style="font-size: 12px; color: #5d5de4;
                           text-decoration: underline; margin-left: 5px;"
                            >Sort</span
                        >
                        <span v-show="sortOrder['start_at'] === 'asc'"
                            >&#9650;</span
                        ><span v-show="sortOrder['start_at'] === 'desc'"
                            >&#9660;</span
                        >
                    </th>
                    <th
                        class="cursor-pointer"
                        @click="sortByColumn('end_at')"
                        scope="col"
                    >
                        End Date
                        <span
                            style="font-size: 12px; color: #5d5de4;
                           text-decoration: underline; margin-left: 5px;"
                            >Sort</span
                        >
                        <span v-show="sortOrder['end_at'] === 'asc'"
                            >&#9650;</span
                        ><span v-show="sortOrder['end_at'] === 'desc'"
                            >&#9660;</span
                        >
                    </th>

                    <th
                        class="cursor-pointer"
                        @click="sortByColumn('discount')"
                        scope="col"
                    >
                        Discount
                        <span
                            style="font-size: 12px; color: #5d5de4;
                           text-decoration: underline; margin-left: 5px;"
                            >Sort</span
                        >
                        <span v-show="sortOrder['discount'] === 'asc'"
                            >&#9650;</span
                        ><span v-show="sortOrder['discount'] === 'desc'"
                            >&#9660;</span
                        >
                    </th>
                    <th scope="col">
                        Discount Type
                    </th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(voucher, index) in vouchers">
                    <td>{{ voucher.code }}</td>

                    <td>{{ formatDate(voucher.start_at) }}</td>
                    <td>{{ formatDate(voucher.end_at) }}</td>
                    <td>{{ voucher.discount }}</td>
                    <td>{{ voucher.type.display }}</td>

                    <td>
                        <button
                            class="btn btn-primary btn-sm mr-1"
                            @click="update_edit(voucher.code)"
                        >
                            <i class="far fa-edit"></i>&nbsp; Edit
                        </button>
                        <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            @click="deleteVoucher(voucher.code)"
                        >
                            <i class="far fa-trash-alt"></i>&nbsp; Delete
                        </button>
                    </td>
                </tr>
            </tbody>
            <ul  class=" pagination flex-wrap"  v-if="shouldShowPagination">
                <li class="page-item" v-for="(page) in totalPages" :class="{'active': (page == currentPage)}" >
                    <a href="#"  class="page-link" @click="getVouchers(page)" >
                    {{page}}
                </a>
                </li>
            </ul>
        </table>
        <div v-else-if="!loading">
            There are currently no vouchers created.
        </div>

        <add-voucher
            v-if="open_add_voucher"
            :edit="edit"
            :get_vouchers="getVouchers"
            :voucher_code="voucher_code"
            :user_id="user_id"
            @closeModal="on_load"
            v-on:updateEdit="update_edit"
            :oms_system="oms_system"
            :token="token"
            :api_url="api_url"
        ></add-voucher>

        <loader :loading="loading"></loader>
    </div>
</template>

<script>
import moment from "moment";
import addVoucher from "./addVoucher.vue";

import loader from "./loader.vue";

export default {
    components: {
        addVoucher,
        loader
    },
    data() {
        return {
            open_add_voucher: false,
            loading: false,
            voucher_code: null,
            edit: null,
            vouchers: [],
            sortOrder: {
                code: "",
                start_at: "",
                end_at: "",
                discount: ""
            },
            currentPage: 0,
            totalPages: 0
        };
    },
    props: ["user_id", "oms_system", "token", "api_url"],
    mounted() {
        this.on_load();
    },
    methods: {
        sortByColumn(sortby_type) {
            this.sortOrder[sortby_type] =
                this.sortOrder[sortby_type] === "asc" ? "desc" : "asc";
            this.loading = true;
            axios
                .get(this.api_url + "/api/v1/vouchers", {
                    params: {
                        system_id: this.oms_system,
                        token: this.token,
                        sortBy: sortby_type,
                        sort_order: this.sortOrder[sortby_type]
                    }
                })
                .then(response => {
                    this.vouchers = response.data.data;
                })
                .catch(err => {
                    alert("Error fetching vouchers");
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        on_load() {
            this.loading = true;
            this.open_add_voucher = false;
            this.getVouchers();
        },
        update_edit(code) {
            this.edit = true;
            this.voucher_code = code;
            this.open_add_voucher = true;
        },
        getVouchers(page) {
            this.loading = true;
            axios
                .get(this.api_url + "/api/v1/vouchers", {
                    params: {
                        system_id: this.oms_system,
                        token: this.token,
                        page: page ? page : ""
                    }
                })
                .then(response => {
                    console.log(response);
                    this.vouchers = response.data.data;
                    this.totalPages = response.data.meta.last_page;
                    this.currentPage = response.data.meta.current_page;

                    this.open_add_voucher = false;
                    this.edit = false;
                })
                .catch(err => {
                    alert("Error fetching vouchers");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        gotoPage(page) {
            this.currentPage = page;
            this.getVouchers();
        },
        deleteVoucher(voucher_code) {
            let confirm = window.confirm(
                "Are you sure you want to delete this voucher?"
            );
            if (confirm) {
                this.loading = true;
                axios
                    .delete(
                        this.api_url + "/api/v1/vouchers/" + voucher_code,

                        {
                            data: {
                                user_id: this.user_id
                            },
                            params: {
                                system_id: this.oms_system,
                                token: this.token
                            }
                        }
                    )
                    .then(response => {
                        this.on_load();
                    })
                    .catch(err => {
                        alert(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        formatDate(timestamp) {
            return moment(timestamp).format("DD/MM/YYYY HH:mm:ss");
        },
    },
    computed: {
        shouldShowPagination() {
            return this.totalPages > 1;
        }
    },

};
</script>
